import { useTranslation } from 'react-i18next';

import { TextWrapper, Wrapper } from './GamificationNotificationContent.styles';

import GAMIFICATION_RAY_ADD from '@/assets/gamification_ray_add.svg';
import GAMIFICATION_RAY_SUBSTRACT from '@/assets/gamification_ray_substract.svg';

type Props = {
  isAdding: boolean;
  points: number;
};

const IMG_SIZE = 24;

export const GamificationNotificationContent: React.FC<Props> = ({ isAdding, points }) => {
  const { t } = useTranslation();

  const text = t(isAdding ? 'ADD_POINTS' : 'SUBSTRACT_POINTS', { points });
  const img = isAdding ? GAMIFICATION_RAY_ADD : GAMIFICATION_RAY_SUBSTRACT;

  return (
    <Wrapper>
      <img src={img} width={IMG_SIZE} height={IMG_SIZE} alt="Gamification ray" />
      <TextWrapper>{text}</TextWrapper>
    </Wrapper>
  );
};
